module.exports = __webpack_public_path__ + "img/5-stars-review-min.65b580b8.png";